<template>
  <div>
    <div class="container-fluid" v-if="download_data">
      <H2>{{ $trans.protocol.header }}</H2>
      <hr>
      <b-form-row>
        <div class="form-group col-sm-3">
          <b-form-checkbox
            v-model="protocol.cause.preliminary"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
          >
            {{ $trans.protocol.cause.preliminary }}
          </b-form-checkbox>
        </div>
        <div class="form-group col-sm-3">
          <b-form-checkbox
            v-model="protocol.cause.final"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
          >
            {{ $trans.protocol.cause.final }}
          </b-form-checkbox>
        </div>
        <div class="form-group col-sm-3">
          <b-form-checkbox
            v-model="protocol.cause.state"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
          >
            {{ $trans.protocol.cause.state }}
          </b-form-checkbox>
        </div>
        <div class="form-group col-sm-3">
          <b-form-checkbox
            v-model="protocol.cause.transmission"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
          >
            {{ $trans.protocol.cause.transmission }}
          </b-form-checkbox>
        </div>
      </b-form-row>
      <hr>
      <b-form-row>
        <div class="form-group col-md-4">
          <label for="object">{{ $trans.protocol.object }}</label>
          <input
            name="object"
            v-model="protocol.object" class="form-control" id="object">
        </div>
        <div class="form-group col-md-4">
          <label for="tenant">{{ $trans.protocol.tenant }}</label>
          <input
            autocomplete="off"
            name="tenant"
            v-model="protocol.tenant" class="form-control" id="tenant">
        </div>
        <div class="form-group col-md-4">
          <label for="street">{{ $trans.protocol.street }}</label>
          <input
            name="street"
            v-model="protocol.street" class="form-control" id="street">
        </div>
      </b-form-row>
      <b-form-row class="mt-2">
        <div class="form-group col">
          <label for="floor" style="float: left; margin-right: 5px;">{{ $trans.protocol.floor }}</label>
          <input
            autocomplete="off"
            name="floor"
            v-model="protocol.floor"
            id="floor"
            class="form-control"
            style="width: 100px; margin: -7px 0px;"
          >
        </div>
      </b-form-row>
      <b-form-row>
        <div class="form-group col " v-for="(item, item_index) in protocol.location">
          <b-form-checkbox
            v-model="protocol.location[item_index]"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
          >
            {{ $trans.protocol.location[item_index] }}
          </b-form-checkbox>
        </div>
      </b-form-row>

      <hr>
      <b-form-row>
        <div class="col-md-4">
          <h3>{{ $trans.protocol.structure_header }}</h3>
          <div v-for="(structure, index) in protocol.structure" class="form-group">
            <input
              autocomplete="off"
              :name="index"
              v-if="index !== 'basement_number_number' && index !== 'attic_number'"
              :id="index"
              v-model="protocol.structure[index]"
              class="form-control inline"
              style="width: 3.5rem; margin-left: 0"
            >
            <label :for="index" v-if="index !== 'basement_number_number' && index !== 'attic_number'">{{
                $trans.protocol.structure[index]
              }}</label>
            <input
              autocomplete="off"
              :name="index"
              v-if="index === 'basement_number' || index === 'attic'"
              :id="index + '_number'"
              v-model="protocol.structure[index + '_number']"
              class="form-control inline"
              style="width: 3.5rem; margin-left: 0"
            >
          </div>
        </div>
        <div class="col-md-4">
          <h3>{{ $trans.protocol.furniture_header }}</h3>
          <table class="table table-bordered">
            <tbody>
            <tr v-for="(items, index) in protocol.furniture">
              <td>
                <div v-for="(item, item_index) in items">
                  <b-form-checkbox
                    v-if="item_index !== 'other_value'"
                    v-model="protocol.furniture[index][item_index]"
                    :value="true"
                    :unchecked-value="false"
                  >
                    {{ $trans.protocol.furniture[index][item_index] }}
                  </b-form-checkbox>
                  <input
                    autocomplete="off"
                    :name="index + item_index"
                    v-else
                    v-model="protocol.furniture[index][item_index]"
                    class="form-control"
                    :id="index"
                    :readonly="!protocol.furniture.heating.other"
                  >
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-4">
          <h3>{{ $trans.protocol.meters_data_header }}</h3>
          <div v-for="(item, index) in protocol.meters_data" class="form-row">
            <b-col cols="6">
              <label :for="index">{{ $trans.protocol.meters_data[index] }}</label>
            </b-col>
            <b-col style="margin-bottom: 1rem;" cols="6">
              <input
                autocomplete="off"
                :name="index"
                :id="index"
                v-model="protocol.meters_data[index]"
                class="form-control inline"
              >
            </b-col>
          </div>
        </div>
      </b-form-row>
      <hr>
      <!--rooms-->
      <b-form v-for="(room, room_index) in protocol.rooms" :id="'room_name_' + room_index">
        <b-form-row>
          <div class="col">
            <h4 style="margin-top: 0.5rem">{{ room.name }}</h4>
          </div>
          <div class="col">
            <b-button
              v-if="room_index > 2"
              class="btn btn-danger float-right"
              @click="delete_room_index = room_index; $bvModal.show('delete_room_modal')"
            >
              {{ $trans.main.button_delete_room }}
            </b-button>
          </div>
        </b-form-row>
        <div class="form-group"
             v-for="(item, item_index) in room"
             v-if="!['boiler_other', 'images', 'images_amount', 'id', 'bath_structure', 'washbasin_structure', 'wall_tile_structure'].includes(item_index)
           && !(item_index === 'name' && +room_index < 3)"
        >
          <label v-if="(typeof item !== 'boolean' && !['notes_text', 'boiler_other', 'bath', 'washbasin', 'wall_tile'].includes(item_index))
          || (item_index === 'bath' && protocol.rooms[room_index]['bath_structure'] === undefined)
          || (item_index === 'washbasin' && protocol.rooms[room_index]['washbasin_structure'] === undefined)
          || (item_index === 'wall_tile' && protocol.rooms[room_index]['wall_tile_structure'] === undefined)"
                 :for="room_index + item_index"
          >
            {{ $trans.protocol.rooms[item_index] }}
          </label>

          <b-row
            v-else-if="item_index === 'bath'"
            :for="room_index + item_index"
            class="mb-2"
          >
            <b-col
              v-for="(checkbox_item, checkbox_index) in protocol.rooms[room_index]['bath_structure']"
              class="col-auto"
            >
              <nobr>
                <b-form-checkbox
                  v-model="protocol.rooms[room_index]['bath_structure'][checkbox_index]"
                  :value="true"
                  :unchecked-value="false"
                  :id="room_index + item_index + checkbox_index"
                  class="custom-control custom-checkbox"
                >
                  {{ $trans.protocol.rooms['bath_structure'][checkbox_index] }}
                </b-form-checkbox>
              </nobr>
            </b-col>
          </b-row>

          <b-row
            v-else-if="item_index === 'washbasin'"
            :for="room_index + item_index"
            class="mb-2"
          >
            <b-col
              v-for="(checkbox_item, checkbox_index) in protocol.rooms[room_index]['washbasin_structure']"
              class="col-auto"
            >
              <nobr>
                <b-form-checkbox
                  v-model="protocol.rooms[room_index]['washbasin_structure'][checkbox_index]"
                  :value="true"
                  :unchecked-value="false"
                  :id="room_index + item_index + checkbox_index"
                  class="custom-control custom-checkbox"
                >
                  {{ $trans.protocol.rooms['washbasin_structure'][checkbox_index] }}
                </b-form-checkbox>
              </nobr>
            </b-col>
          </b-row>


          <b-row
            v-else-if="item_index === 'wall_tile'"
            :for="room_index + item_index"
            class="mb-2"
          >
            <b-col class="col-auto">
              {{ $trans.protocol.rooms['wall_tile_structure']['wandfliesen'] }}
            </b-col>
            <b-col class="col-auto">
              <b-form-checkbox
                v-model="protocol.rooms[room_index]['wall_tile_structure']['raumhoch']"
                :value="true"
                :unchecked-value="false"
                :id="room_index + item_index + 'raumhoch'"
                class="custom-control custom-checkbox"
              >
                {{ $trans.protocol.rooms['wall_tile_structure']['raumhoch'] }}
              </b-form-checkbox>
            </b-col>
            <b-col class="col-auto">
              <b-form-checkbox
                v-model="protocol.rooms[room_index]['wall_tile_structure']['halbhoch']"
                :value="true"
                :unchecked-value="false"
                :id="room_index + item_index + 'halbhoch'"
                class="custom-control custom-checkbox"
              >
                {{ $trans.protocol.rooms['wall_tile_structure']['halbhoch'] }}
              </b-form-checkbox>
            </b-col>
            <b-col class="col-auto">
              <b-form-checkbox
                v-model="protocol.rooms[room_index]['wall_tile_structure']['turhoch']"
                :value="true"
                :unchecked-value="false"
                :id="room_index + item_index + 'turhoch'"
                class="custom-control custom-checkbox"
              >
                {{ $trans.protocol.rooms['wall_tile_structure']['turhoch'] }}
              </b-form-checkbox>
            </b-col>

          </b-row>
          <b-form-checkbox
            v-if="typeof item === 'boolean' && item_index !== 'access'"
            :class="item_index.indexOf('boiler') > -1 ? ' float-left ': ''"
            :style="item_index.indexOf('boiler') > -1 ? ' margin-right: 5px; ' : ''"
            v-model="protocol.rooms[room_index][item_index]"
            :value="true"
            :id="room_index + item_index"
            :unchecked-value="false"
          >
            {{ $trans.protocol.rooms[item_index] }}
          </b-form-checkbox>
          <b-form-group
            v-else-if="typeof item === 'boolean' && item_index === 'access'"
            :id="room_index + item_index"
            :label="trans.protocol.rooms[item_index]"
          >
            <b-form-radio-group
              :id="room_index + item_index + '-radio-slots'"
              v-model="protocol.rooms[room_index][item_index]"
              :options="[{text: trans.main.boolean.true, value: true}, {text: trans.main.boolean.false, value: false}]"
            >
            </b-form-radio-group>
          </b-form-group>
          <textarea
            rows="5"
            v-else-if="item_index === 'notes_text'"
            v-model="protocol.rooms[room_index][item_index] "
            class="form-control"
            :id="room_index + item_index"
            :readonly="!protocol.rooms[room_index].notes"
            autocomplete="off"
          ></textarea>
          <input
            :autocomplete="['radiator_value',].includes(item_index) ? 'off' : 'on'"
            :name="item_index"
            v-else-if="item_index !== 'exist_boiler_other'"
            v-model="protocol.rooms[room_index][item_index] "
            class="form-control"
            :id="room_index + item_index"
          >
          <input
            :autocomplete="['radiator_value',].includes(item_index) ? 'off' : 'on'"
            :name="item_index"
            v-if="item_index === 'exist_boiler_other' "
            :readonly="!protocol.rooms[room_index].exist_boiler_other"
            style="margin-left: 1rem; width: 300px"
            class="form-control inline ml-1 mt-2 "
            id="boiler_other"
            v-model="protocol.rooms[room_index].boiler_other"
          >
        </div>
        <div class="form-row" style="margin-bottom: 3em">
          <div v-for="(image, image_index) in room.images" class="rounded float-left thumbnail img-responsive p-1">
            <div class="row">
              <div class="col">
                <img :src="image.small.blob" @click="openBigImage(image)"
                     class="rounded float-left img-thumbnail thumbnail">
              </div>
            </div>
            <div class="row">
              <div class="col">
                <b-button class="btn-danger btn-block border-bottom-0 mb-1"
                          @click="deleteImage(room_index, image_index)">{{
                    $trans.main.button_delete
                  }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <label class="btn btn-primary btn-block">
            <input
              autocomplete="off"
              name="add_image"
              class="" type="file" accept="image/*" capture="camera"
              @change="filesChange($event.target.files[0], room_index)" hidden/>
            {{ $trans.main.button_add_image }}
          </label>
        </div>
        <hr>
      </b-form>
      <b-modal size="xl" id="modal-big-image" hide-footer hide-header>
        <div class="d-block text-center">
          <img :src="modal_image" class="img-fluid">
        </div>
        <b-button class="mt-3" block @click="$bvModal.hide('modal-big-image')">{{
            trans.main.button_success
          }}
        </b-button>
      </b-modal>
      <b-form>
        <div class="form-group">
          <b-button class="btn btn-success form-control" @click="addRoom()">{{
              $trans.protocol.rooms.button_add
            }}
          </b-button>
        </div>
        <hr>
      </b-form>
      <!--/rooms-->
      <b-form>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.basement_description"
            :value="true"
            id="basement_description"
            :unchecked-value="false"
          >
            {{ $trans.protocol.basement_description }}
          </b-form-checkbox>
          <textarea
            rows="5"
            v-model="protocol.basement_description_text "

            class="form-control"
            id="basement_description_text"
            :readonly="!protocol.basement_description"
          ></textarea>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.balcony_description"
            :value="true"
            id="balcony_description"
            :unchecked-value="false"
          >
            {{ $trans.protocol.balcony_description }}
          </b-form-checkbox>
          <textarea
            rows="5"
            v-model="protocol.balcony_description_text "

            class="form-control"
            id="balcony_description_text"
            :readonly="!protocol.balcony_description"
          ></textarea>
        </b-form-group>
        <hr>
      </b-form>
      <b-form>
        <b-form-group>
          <label for="remarks">
            {{ $trans.protocol.remarks }}
          </label>
          <textarea
            rows="5"
            v-model="protocol.remarks"

            class="form-control"
            id="remarks"
          ></textarea>
        </b-form-group>
        <hr>
      </b-form>

      <b-form>
        <p><strong>{{ $trans.protocol.state_header }}</strong></p>
        <b-form-group
          id="maintenance_boiler"
        >
          <b-form-row>
            <label style="margin-right: 0.5rem;">{{ trans.protocol.maintenance_boiler_header }}</label>
            <b-form-checkbox
              class="custom-control-inline"
              id="maintenance_boiler_checkbox1"
              v-model="protocol.maintenance_boiler_done"
              :value="true"
              :unchecked-value="false"
              name="maintenance_boiler_checkbox1"
            >
              <label>{{ trans.protocol.maintenance_boiler_done }}</label>
            </b-form-checkbox>
            <input
              autocomplete="off"
              name="maintenance_boiler_done"
              :readonly="!protocol.maintenance_boiler_done"
              type="date"
              class="form-control inline"
              style="margin-left: 0; margin-right: 0"
              id="maintenance_boiler_date"
              v-model="protocol.maintenance_boiler_date"
            > <label style="margin-left: 0.5rem; margin-right: 1rem;">durchgeführt</label>
            <b-form-checkbox
              class="custom-control-inline"
              id="maintenance_boiler_not_done_checkbox"
              v-model="protocol.maintenance_boiler_not_done"
              :value="true"
              :unchecked-value="false"
              name="maintenance_boiler_checkbox2"
            >
              <label> {{ trans.protocol.maintenance_boiler_not_done }}</label>
            </b-form-checkbox>
            <b-form-checkbox
              v-model="protocol.maintenance_boiler_executor_owner"
              :value="true"
              id="maintenance_boiler_executor_owner"
              :unchecked-value="false"
            >
              {{ $trans.protocol.maintenance_boiler_executor_owner }}
            </b-form-checkbox>
          </b-form-row>
        </b-form-group>
        <b-form-group
          id="warmly_pays"
        >
          <b-form-row>
            <label style="margin-right: 0.5rem;"> {{ trans.protocol.warmly_pays }}</label>
            <b-form-radio-group
              class="custom-control-inline"
              id="warmly_pays-radio"
              v-model="protocol.warmly_pays"
              :options="[{text: trans.protocol.warmly_pays_tenant, value: true}, {text: trans.protocol.warmly_pays_owner, value: false}]"
              name="warmly_pays"
            >
            </b-form-radio-group>
          </b-form-row>
        </b-form-group>
        <hr>
      </b-form>
      <b-form>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.tenant_eliminate_defects"
            :value="true"
            id="tenant_eliminate_defects"
            :unchecked-value="false"
          >
            {{ $trans.protocol.tenant_eliminate_defects }}
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <input
            autocomplete="off"
            name="tenant_eliminate_defects"
            :readonly="!protocol.tenant_eliminate_defects"
            type="date"
            class="form-control inline ml-0"
            id="tenant_eliminate_defects_method"
            v-model="protocol.tenant_eliminate_defects_method"
          >
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.tenant_warned_of_deadline"
            :value="true"
            id="tenant_warned_of_deadline"
            :unchecked-value="false"
          >
            {{ $trans.protocol.tenant_warned_of_deadline }}
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.repairs_delegates_the_execution"
            :value="true"
            id="repairs_delegates_the_execution"
            :unchecked-value="false"
          >
            {{ $trans.protocol.repairs_delegates_the_execution }}
          </b-form-checkbox>
          <b-form-radio
            class="custom-control-inline"
            style="line-height: 1.9;"
            id="repairs_budget_tenant"
            v-model="protocol.repairs_budget"
            :value="trans.protocol.repairs_budget_tenant"
            :checked="protocol.repairs_budget === trans.protocol.repairs_budget_tenant"
            :disabled="!protocol.repairs_delegates_the_execution"
          >
            <strong style="line-height: 1.9;">{{ trans.protocol.repairs_budget_tenant }}</strong>
          </b-form-radio>
          <b-form-radio
            class="custom-control-inline"
            style="line-height: 1.9; margin: 0;"
            id="repairs_budget_rent"
            v-model="protocol.repairs_budget"
            :value="trans.protocol.repairs_budget_rent"
            :checked="protocol.repairs_budget === trans.protocol.repairs_budget_rent"
            :disabled="!protocol.repairs_delegates_the_execution"
          >
          </b-form-radio>
          <strong style="word-wrap: break-word; line-height: 1.9; margin-left: -0.5rem; margin-right: 0;"
                  class="custom-control-inline">{{ trans.protocol.repairs_budget_rent }}
          </strong>
          {{ trans.protocol.repairs_budget_rent2 }}
        </b-form-group>
        <b-form-group>
          <input
            autocomplete="off"
            name="repairs_delegates_the_execution"
            type="date"
            class="ml-0 form-control inline "
            v-model="protocol.repairs_deadline"
            :readonly="!protocol.repairs_delegates_the_execution"
          >
          {{ $trans.protocol.repairs_delegates_the_execution2 }}
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.tenant_refuses_to_eliminate"
            :value="true"
            id="tenant_refuses_to_eliminate"
            :unchecked-value="false"
          >
            {{ $trans.protocol.tenant_refuses_to_eliminate }}
          </b-form-checkbox>
          <textarea v-if="protocol.tenant_refuses_to_eliminate"
                    rows="2"
                    v-model="protocol.tenant_refuses_to_eliminate_reason"

                    class="form-control"
                    id="tenant_refuses_to_eliminate_reason"
          ></textarea>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            inline
            v-model="protocol.tenant_eliminate_defects_pays"
            :value="true"
            id="tenant_eliminate_defects_pays"
            :unchecked-value="false"
          >
            {{ $trans.protocol.tenant_eliminate_defects_pays_sum }}
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <input
            autocomplete="off"
            name="tenant_eliminate_defects_pays_sum"
            :readonly="!protocol.tenant_eliminate_defects_pays"
            v-model="protocol.tenant_eliminate_defects_pays_sum "
            class="form-control inline ml-0"
            id="tenant_eliminate_defects_pays_sum"
          >
          {{ $trans.main.currency }}
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.strange_text"
            :value="true"
            id="strange_text"
            :unchecked-value="false"
          >
            {{ $trans.protocol.strange_text }}
          </b-form-checkbox>
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.barter"
            :value="true"
            id="barter"
            :unchecked-value="false"
          >
            {{ $trans.protocol.barter }}
          </b-form-checkbox>
          <input
            autocomplete="off"
            name="barter_text"
            v-if="protocol.barter"
            v-model="protocol.barter_text "
            class="form-control"
            id="barter_text"
          >
        </b-form-group>
        <b-form-group>
          <b-form-checkbox
            v-model="protocol.accept"
            :value="true"
            id="accept"
            :unchecked-value="false"
          >
            {{ $trans.protocol.accept1 }}
            <b-form-radio-group
              id="condition-radio-slots"
              v-model="protocol.condition"
              :options="[
            {text: trans.protocol.condition_perfect, value: trans.protocol.condition_perfect},
            {text: trans.protocol.condition_satisfactory, value: trans.protocol.condition_satisfactory},
            {text: trans.protocol.condition_agreement, value: trans.protocol.condition_agreement}
          ]"
            >
            </b-form-radio-group>
            {{ $trans.protocol.accept2 }}<br>
            <label>{{ $trans.protocol.accept3 }}</label>
          </b-form-checkbox>
        </b-form-group>
        <hr>
        <b-form-group>
          <label for="new_address">{{ $trans.protocol.new_address }}</label>
          <input
            autocomplete="off"
            name="new_address"
            v-model="protocol.new_address"
            class="form-control"
            id="new_address"
          >
        </b-form-group>
        <b-form-group>
          <label for="kontoverbindung">{{ $trans.protocol.kontoverbindung }}</label>
          <input
            autocomplete="off"
            name="kontoverbindung"
            v-model="protocol.kontoverbindung"
            class="form-control"
            id="kontoverbindung"
          >
        </b-form-group>
        <hr>
        <h4>{{ $trans.protocol.keys_header }}</h4>
        <b-form-row>
          <div v-for="(value, key) in protocol.keys" class="col-3">
            <label :for="'key_' + key">
              {{ $trans.protocol.keys[key] }}
            </label>
            <b-input
              v-model="protocol.keys[key]"
              autocomplete="off"
              class="form-control"
              :id="'key_' + key"
            ></b-input>
          </div>
        </b-form-row>
        <hr>
        <b-form-group>
        <textarea
          rows="5"
          v-model="protocol.notices"
          class="form-control"
          id="notices"
        ></textarea>
        </b-form-group>
        {{ $trans.protocol.footer_text }}
        <hr>
      </b-form>
      <!--signature-->
      <h4>Unterschriften</h4>
      <b-form-row>
        <div :id="protocol.api_id + '_' + protocol.id +  'signature_owner'" class="col-3">
          <div class="form-group">
            <img class="img-fluid" :src="protocol.signature_owner">
            <b-button
              @click="signatureEdit('signature_owner')"
              class="form-control btn-info">
              {{ $trans.protocol.signature_owner }}
            </b-button>
          </div>
        </div>
        <div :id="protocol.api_id + '_' + protocol.id +  'signature_inspector'" class="col-3">
          <div class="form-group">
            <img class="img-fluid" :src="protocol.signature_inspector">
            <b-button
              @click="signatureEdit('signature_inspector')"
              class="form-control btn-info"
            >
              {{ $trans.protocol.signature_inspector }}
            </b-button>
          </div>
        </div>
        <div :id="protocol.api_id + '_' + protocol.id +  'signature_tenant'" class="col-3">
          <div class="form-group">
            <img class="img-fluid" :src="protocol.signature_tenant">
            <b-button
              @click="signatureEdit('signature_tenant')"
              class="form-control btn-info"
            >
              {{ $trans.protocol.signature_tenant }}
            </b-button>
          </div>
        </div>
        <div :id="protocol.api_id + '_' + protocol.id +  'signature_old_tenant'" class="col-3">
          <div class="form-group">
            <img class="img-fluid" :src="protocol.signature_old_tenant">
            <b-button
              @click="signatureEdit('signature_old_tenant')"
              class="form-control btn-info"
            >
              {{ $trans.protocol.signature_old_tenant }}
            </b-button>
          </div>
        </div>
        Unterschriften wurden digital erfasst
      </b-form-row>
      <hr>
      <b-form-row>
        <div class="col">
          <h4>Datum</h4>
        </div>
        <div class="col">
          <input
            autocomplete="off"
            name="date"
            type="date" class="form-control" v-model="protocol.date">
        </div>
      </b-form-row>
      <hr>
      <h4>Email-Adressen</h4>
      <b-form-row>
        <div class="col">
          <b-form-group>
            <label for="email_owner">{{ $trans.protocol.email_owner }}</label>
            <input
              autocomplete="off"
              name="email_owner"
              v-model="protocol.email_owner" class="form-control" id="email_owner">
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group>
            <label for="email_inspector">{{ $trans.protocol.email_inspector }}</label>
            <input
              autocomplete="off"
              name="email_inspector"
              v-model="protocol.email_inspector" class="form-control" id="email_inspector">
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group>
            <label for="email_tenant">{{ $trans.protocol.email_tenant }}</label>
            <input
              autocomplete="off"
              name="email_tenant"
              v-model="protocol.email_tenant" class="form-control" id="email_tenant">
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group>
            <label for="email_old_tenant">{{ $trans.protocol.email_old_tenant }}</label>
            <input
              autocomplete="off"
              name="email_old_tenant"
              v-model="protocol.email_old_tenant" class="form-control" id="email_old_tenant">
          </b-form-group>
        </div>
        <hr>
      </b-form-row>

      <b-form class="sticky-bottom">
        <div v-if="await_spinner" class="form-group">
          <b-spinner variant="success"></b-spinner>
        </div>
        <div v-else class="form-group">
          <b-button class="btn btn-success px-1" @click="save(false, false)">{{
              $trans.protocol.button_save
            }}
          </b-button>
          <b-button class="btn btn-success px-1" @click="save(false, true)">{{
              $trans.protocol.button_save_and_close
            }}
          </b-button>
          <b-button class="btn btn-success px-1" @click="save(true, true)">{{
              $trans.main.button_save_and_send_mails
            }}
          </b-button>
          <b-button class="btn btn-primary px-1" @click="$bvModal.show('copy_modal')">{{
              $trans.main.button_copy
            }}
          </b-button>
          <b-button v-if="!local" class="btn btn-secondary px-1" @click="getPdf()">{{
              $trans.main.button_get_pdf
            }}
          </b-button>
          <b-button v-if="local" class="btn btn-danger px-1" @click="back()">Abbrechen und Daten löschen</b-button>
        </div>
      </b-form>
      <b-modal
        hide-footer
        hide-header
        id="copy_modal"
        color="warning"
      >
        {{ $trans.main.warning_copy }}
        <b-button variant="outline-secondary" block class="btn mt-3" @click="$bvModal.hide('copy_modal')">
          {{ $trans.main.button_cancel }}
        </b-button>
        <b-button
          variant="outline-success"
          block class="btn mt-3"
          @click="$bvModal.hide('copy_modal'); copy()"
        >
          {{ $trans.main.button_copy }}
        </b-button>
      </b-modal>
      <b-modal
        hide-footer
        hide-header
        id="delete_room_modal"
        color="warning"
      >
        {{ $trans.main.delete_room_warning }}
        <b-button variant="outline-secondary" block class="btn mt-3" @click="$bvModal.hide('delete_room_modal')">
          {{ $trans.main.button_cancel }}
        </b-button>
        <b-button
          variant="outline-danger"
          block class="btn mt-3"
          @click="$bvModal.hide('delete_room_modal'); deleteRoom()"
        >
          {{ $trans.main.button_delete }}
        </b-button>
      </b-modal>
    </div>
    <div class="container" v-else>
      <div class="col">
        <div class="col d-flex justify-content-center">
          <b-spinner variant="success"></b-spinner>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapActions} from 'vuex'
import Protocol from '@/classes/protocol'
import trans from '@/language/de'
import axios from 'axios'
import api from '../../functions/api'
import db from '../../functions/idb'
import images from '../../functions/images'

export default {
  name: 'ProtocolEditComponent',
  props: [
    'new',
    'local',
    'id'
  ],
  data () {
    return {
      api_id: undefined,
      local_id: undefined,
      protocol: new Protocol(),
      trans: trans,
      images: images,
      modal_image: '',
      download_data: false,
      await_spinner: false,
      delete_room_index: ''
    }
  },
  watch: {
    protocol: {
      handler () {
        if (this.local) {
          this.protocol.saveIdb()
        }
      },
      deep: true
    }
  },
  async mounted () {
    this.local = this.$route.path.indexOf('local') > -1
    if (this.$store.getters.getCurrentProtocol.update_signature !== undefined && this.$store.getters.getCurrentProtocol.update_signature) {
      this.protocol = await this.protocol.init(await this.$store.getters.getCurrentProtocol)
    } else {
      if (this.new) {
        await this.protocol.saveIdb()
        this.protocol = await this.protocol.createSignature()
      } else {
        let result = await this.getProtocol({id: this.$route.params.id, local: this.local})
        this.protocol = await this.protocol.init(result)
      }
    }
    this.$store.commit('SET_PROTOCOL', {protocol: this.protocol})
    this.download_data = true
    this.$nextTick(() => {
      const elem = document.querySelector('.img-fluid')
      if (elem !== undefined) {
        this.loadSignature()
      }
    })
  },
  methods: {
    ...mapActions(['newProtocol', 'getProtocol']),
    async save (sendMails, redirect = false) {
      this.await_spinner = true
      this.download_data = false
      this.protocol.draft = false
      if (navigator.onLine) {
        try {
          let response = await api.updateProtocol(this.protocol, sendMails)
          await db.deleteProtocol(this.protocol)
          if (redirect) {
            await this.$router.push({name: 'ApiProtocols'})
          } else {
            if (this.$route.name === 'ApiProtocolEdit') {
              let result = await this.getProtocol({id: response, local: false})
              this.protocol = await this.protocol.init(result)
              this.await_spinner = false
            } else {
              await this.$router.push('/protocols/' + response)
            }
          }
        } catch (err) {
          console.log(err)
          await db.updateProtocol(this.protocol)
          redirect ? await this.$router.push({name: 'LocalProtocols'}) : this.await_spinner = false
        }
      } else {
        await db.updateProtocol(this.protocol)
        redirect ? await this.$router.push({name: 'LocalProtocols'}) : this.await_spinner = false
      }
      this.download_data = true
    },
    async copy () {
      this.await_spinner = true
      let newProtocol = await this.protocol.copy()
      await this.$router.push('/local/protocols/' + newProtocol.id)
    },
    async back () {
      this.await_spinner = true
      await this.protocol.delete()
      await this.$router.push({name: 'ApiProtocols'})
    },
    signatureEdit (subject) {
      this.$store.commit('SET_PROTOCOL', {protocol: this.protocol})
      this.$router.push({name: 'Signature', params: {subject: subject}})
    },
    loadSignature () {
      if (this.protocol.update_signature) {
        window.scrollTo(0, document.body.scrollHeight)
      }
      this.protocol.update_signature = false
    },
    addRoom () {
      let room = {
        id: this.protocol.rooms.length,
        name: this.$trans.protocol.rooms.room + ' ' + (this.protocol.rooms.length - 2),
        access: false,
        ceiling: '',
        walls: '',
        window: '',
        doors: '',
        radiator: '',
        radiator_value: '',
        plinth: '',
        floor: '',
        tenants_property: false,
        notes: false,
        notes_text: '',
        images: []
      }
      this.protocol.rooms.push(room)
      this.$nextTick(() => {
        const elem = document.getElementById('room_name_' + (room.id + 1))
        if (elem !== undefined) {
          elem.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          })
        }
      })
    },
    deleteRoom () {
      this.protocol.rooms.splice(this.delete_room_index, 1)
    },
    async filesChange (file, roomIndex) {
      let htmlImage = await this.newHtmlImage(file)
      let fileLink = document.createElement('a')
      fileLink.href = htmlImage.src
      fileLink.setAttribute('download', Date.now() + '.jpg')
      document.body.appendChild(fileLink)
      fileLink.click()
      let imageRoom = {
        small: {
          blob: await this.images.imageToBase64(await this.saveImageMin(htmlImage))
        },
        main: {
          blob: await this.images.imageToBase64(await this.saveImage(htmlImage))
        }
      }
      this.protocol.rooms[roomIndex].images.push(imageRoom)
    },
    deleteImage (roomId, imageId) {
      this.protocol.rooms[roomId].images.splice(imageId, 1)
    },
    async openBigImage (image) {
      this.modal_image = image.main.blob
      this.$bvModal.show('modal-big-image')
    },
    async newHtmlImage (file) {
      return new Promise(function (resolve, reject) {
        let img = new Image()
        img.src = URL.createObjectURL(file)
        img.onload = function () {
          resolve(img)
        }
      })
    },
    getPdf: function () {
      this.await_spinner = true
      axios({
        url: 'protocols/' + this.$route.params.id + '/pdf',
        method: 'GET',
        responseType: 'blob'
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]))
        var fileLink = document.createElement('a')

        fileLink.href = fileURL
        fileLink.setAttribute('download', 'Protokoll' + this.$route.params.id + '.pdf')
        document.body.appendChild(fileLink)

        fileLink.click()
        this.await_spinner = false
      })
    },
    saveImage (image) {
      return new Promise(function (resolve, reject) {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')
        let height = 512
        let scaleFactor = height / image.height
        canvas.width = image.width * scaleFactor
        canvas.height = height
        context.drawImage(image, 0, 0, image.width * scaleFactor, height)
        canvas.toBlob(function (blob) {
          resolve(blob)
        }, 'image/jpeg', 0.80)
      })
    },
    saveImageMin (image) {
      return new Promise(function (resolve, reject) {
        let canvas = document.createElement('canvas')
        let context = canvas.getContext('2d')

        let width = 120
        let scaleFactor = width / image.width
        canvas.width = width
        canvas.height = image.height * scaleFactor

        context.drawImage(image, 0, 0, width, image.height * scaleFactor)
        canvas.toBlob(function (blob) {
          resolve(blob)
        }, 'image/jpeg', 0.80)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/protocols/ProtocolEditComponent.vue